var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubbishGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131.559 131.559",
    style: {
      enableBackground: "new 0 0 131.559 131.559"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Rubbish_-_Grey"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M22.52,75.207l8.958,35.361 c0.319,1.258,1.45,2.139,2.748,2.139h19.352c1.291,0,2.419-0.872,2.743-2.121l9.198-35.379"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M47.822,52.215L47.822,52.215 c1.077-1.273,2.66-2.007,4.328-2.007H63.27l18.132-8.242c0.737-0.335,1.537-0.508,2.346-0.508h15.176 c2.79,0,5.166,2.031,5.6,4.787l4.48,28.437c0.271,1.72-1.059,3.276-2.8,3.276h-4.434l-2.559,35.236 c-0.108,1.482-1.341,2.629-2.827,2.629H79.407c-1.486,0-2.72-1.148-2.827-2.63l-3.81-52.724L67.204,63.9 c-0.447,0.276-0.962,0.422-1.488,0.422H52.08c-1.91,0-3.691-0.961-4.739-2.558l-0.09-0.138 C45.334,58.709,45.567,54.879,47.822,52.215z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    cx: 88.19,
    cy: 24.674,
    r: 8.938
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 88.19,
    y1: 82.457,
    x2: 88.19,
    y2: 114.791
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D7D7D7"
    },
    cx: 40.103,
    cy: 78.64,
    r: 8.938
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M113.11,129.559H18.449 C9.364,129.559,2,122.195,2,113.11V18.449C2,9.364,9.364,2,18.449,2h94.662c9.084,0,16.449,7.364,16.449,16.449v94.662 C129.559,122.195,122.195,129.559,113.11,129.559z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubbishGrey);
export default __webpack_public_path__ + "static/media/Rubbish - Grey.d6a0ef4314d6d0bb8d8bebb641304d63.svg";
export { ForwardRef as ReactComponent };